module.exports = __webpack_public_path__ + "04_face.cceaa607.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer1/04_face.png
// module id = cWLF
// module chunks = 0